import { Cover } from "@circle-react/components/QuickPostV3/Composer/Cover";
import { TipTap } from "@circle-react/components/QuickPostV3/Composer/TipTap";
import { Title } from "@circle-react/components/QuickPostV3/Composer/Title";
import { Trix } from "@circle-react/components/QuickPostV3/Composer/Trix";
import { useComposerSpace } from "@circle-react/components/QuickPostV3/hooks/useComposerSpace";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface PostFieldsProps {
  shouldShowTipTap: boolean;
}

export const PostFields = ({ shouldShowTipTap }: PostFieldsProps) => {
  const { hasCover, hasSelectedSpace, canShowCover, canShowTitle } =
    useComposerSpace();

  return (
    <div
      className={classNames(
        "flex min-h-0 flex-1 flex-col",
        !hasSelectedSpace && "pb-6",
      )}
    >
      {canShowCover && (
        <div className="shrink-0">
          <Cover />
        </div>
      )}
      <div className="flex min-h-0 flex-1 flex-col" data-ai-scrollable>
        {canShowTitle && (
          <div
            className={classNames(
              "mx-auto w-full max-w-3xl shrink-0 px-6",
              hasCover ? "pt-3" : "pt-5",
            )}
          >
            <Title />
          </div>
        )}
        <div
          className={classNames(
            "mx-auto flex w-full max-w-3xl flex-1 flex-col px-6",
            !canShowTitle && (hasCover ? "pt-3" : "pt-5"),
          )}
        >
          <div className="min-h-0 flex-1">
            {shouldShowTipTap ? <TipTap /> : <Trix />}
          </div>
        </div>
      </div>
    </div>
  );
};
